import Helpers from "../../resources/js/utils/helpers";

export default class ChatNotes extends Helpers {
  constructor() {
    super();
    this.sectionChat = document.querySelector('.chat-notes');
    if (!this.sectionChat) return;
    this.formChat = this.sectionChat.querySelector('.js-chat-form');
    this.stopSectionContent = this.sectionChat.querySelector('.chat-notes__stopped-state');
    this.submitBtnForm = this.formChat.querySelector('.js-submit-btn');
    this.submitBtn = this.submitBtnForm.querySelector('.submit-block');
    this.submitBtnStop = this.submitBtnForm.querySelector('.submit-block-stop');
    this.chatPreview = this.sectionChat.querySelector('.chat-notes__chat-preview');
    this.loadText = this.sectionChat.querySelector('.chat-notes__wrapper-search');
    this.searchText = this.loadText.querySelector('.search-text');
    this.msSearch = this.loadText.querySelector('.ms-search');
    this.chatResult = this.sectionChat.querySelector('.chat-notes__chat-window-result');
    this.chatWindow = this.sectionChat.querySelector('.chat-notes__chat-window');
    this.textArea = this.sectionChat.querySelector('.chat-notes__chat-form-textarea');
    this.formChat && this.formChat.addEventListener('submit', this.handleChatForm.bind(this));
    this.btnsHandle = this.sectionChat.querySelector('.chat-btn-handle-js');
    Helpers.registerHandler('click', this.printChatOnly.bind(this), '.btn-print-js');
    Helpers.registerHandler('click', this.copyChatToClipboard.bind(this), '.btn-copy-js');
    Helpers.registerHandler('click', this.abortChatRequest.bind(this), '.js-submit-btn');
    this.isLoad = false;
    this.isRender = false;
    this.loadingInfo = [];
    this.parseUrl();
    this.textAreaSubmit();
  }

  async abortChatRequest() {
    if (this.abortController && this.isLoad && !this.isRender) {
      this.abortController.abort();

      if (this.currentRequestId) {
        try {
          let apiUrlStop = `${themeVars.generalApi}/quote/stop`;

          await fetch(apiUrlStop, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ request_id: this.currentRequestId }),
          });
          this.renderStopChat(this.loadingInfo, this.chatResult);
          console.log(`Server request is stop - request_id: ${this.currentRequestId}`);
        } catch (err) {
          console.error('Error server:', err);
        }
      }
    }
    this.isLoad = false;
    this.submitBtn.classList.remove('hidden');
    this.submitBtnStop.classList.add('hidden');
  }

  generateRequestId() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return crypto.randomUUID();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  renderStopChat(details = [], el = null) {
    const parentBlock = document.createElement('div');
    const timeBlock = document.createElement('span');
    const aiName = document.createElement('span');
    const answer = document.createElement('div');
    const iconBlock = document.createElement('div');
    iconBlock.className = 'logo-icon-answer';
    iconBlock.innerHTML = `
    <svg width="33" height="33">
      <use href="#icon-search-chat"/>
    </svg>
  `;

    parentBlock.appendChild(timeBlock)
    parentBlock.appendChild(aiName)
    parentBlock.appendChild(iconBlock)
    parentBlock.appendChild(answer)
    parentBlock.className = 'answer-wrapper';
    timeBlock.className = 'answer-time';
    answer.className = 'answer';
    aiName.className = 'ai-name';
    aiName.innerText = 'Escribió:';
    timeBlock.innerText = this.formatDate(new Date(), 'HH:mm');
    const stopSection = this.stopSectionContent.cloneNode(true);
    if(details.length) {
      const list = stopSection.querySelector('.chat-notes__stopped-state--list-proccess');
      details.forEach((item) => {
        const itemList = document.createElement('li');
        const itemText = document.createElement('span');
        itemText.innerText = item.message;
        const itemMs = document.createElement('span');
        itemMs.innerText = item.elapsed_ms;
        itemList.appendChild(itemText);
        itemList.appendChild(itemMs);
        list.appendChild(itemList);
      })
    }

    stopSection.classList.remove('hide');
    parentBlock.appendChild(stopSection);
    el.appendChild(parentBlock);
  }

  textAreaSubmit() {
    if (!this.textArea) return;
    this.textArea.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        if (e.shiftKey) return;
        e.preventDefault();
        this.formChat.requestSubmit();
      }
    })
  }

  copyChatToClipboard() {
    this.copyBlockText(this.chatResult)
  }

  printChatOnly() {
    this.printBlock('Chat notes', this.chatResult)
  }

  parseUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const question = urlParams.get('question');

    if (question) {
      this.textArea.value = question;
      this.formChat.requestSubmit();
    }
  }

  async handleChatForm(e) {
    e.preventDefault();
    if (this.isLoad) return;
    const formData = new FormData(e.target);
    let text = formData.get('question');
    text = text.trim();
    if (!text) return;
    this.isLoad = true;
    this.isRender = false;
    this.abortController = new AbortController();
    const signal = this.abortController.signal;
    this.currentRequestId = this.generateRequestId();
    try {
      this.loadingInfo = [];
      const data = {
        question: text,
        k: 8,
        model: "hybrid",
        request_id: this.currentRequestId,
        chat_context: null,
        // question: "¿Qué dice Ortega sobre el hombre-masa?",
      };
      this.renderQuestion(text, this.chatResult);
      e.target.reset();
      this.submitBtn.classList.add('hidden');
      this.submitBtnStop.classList.remove('hidden');
      this.chatPreview.classList.add('hide');
      this.loadText.classList.add('show');
      this.chatWindow.classList.add('scrollbar-visible');
      this.chatWindow.scrollTo({
        top: this.chatWindow.scrollHeight,
        behavior: 'smooth',
      });
      const apiUrl = `${themeVars.generalApi}/quote/stream`;

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
        signal: signal,
      });
      if (!response.ok || !response.body) {
        throw new Error(`HTTP ${response.status}`);
      }
      let dataResult = null;

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = "";

      // eslint-disable-next-line no-constant-condition
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });
        let newlineIndex = buffer.indexOf("\n");

        while (newlineIndex >= 0) {
          const line = buffer.slice(0, newlineIndex).trim();
          buffer = buffer.slice(newlineIndex + 1);
          newlineIndex = buffer.indexOf("\n");

          if (!line) continue;

          const event = JSON.parse(line);

          if (event.type === "progress") {
            this.searchText.setAttribute('data-text', event.data.message);
            this.searchText.innerText = event.data.message;
            const seconds = Math.round(event.data.elapsed_ms / 1000);
            this.msSearch.innerText = `${seconds}s`;
            // console.log("Progress:", event.data);
            this.loadingInfo.push({
              message: event.data.message,
              elapsed_ms: `${seconds}s`,
            });
          } else if (event.type === "result") {
            // console.log("Final answer:", event.data);
            dataResult = event.data;

          } else if (event.type === "error") {
            // console.error("Error:", event.data);
          }
        }
      }

      if(dataResult) {
        this.loadText.classList.remove('show');
        this.submitBtn.classList.remove('hidden');
        this.submitBtnStop.classList.add('hidden');
        this.isRender = true;
        this.abortController = null;
        await this.renderAnswer(dataResult, this.chatResult);
      }

      // if (buffer.trim()) {
      //   const event = JSON.parse(buffer.trim());
      //   console.log("tail event", event);
      // }
    } catch (e) {
      console.log(e, 'error')
      this.isLoad = false;
      // await this.renderAnswer({answer: `Error: "${e}".`}, this.chatResult);
    } finally {
      this.loadText.classList.remove('show');
      this.submitBtn.classList.remove('hidden');
      this.isLoad = false;
      this.isRender = false;
      this.abortController = null;
      this.submitBtnStop.classList.add('hidden');
      if(this.btnsHandle.classList.contains('hide')) {
        this.btnsHandle.classList.remove('hide');
      }
    }
  }

  async renderQuote(obj, el = null) {
    if (!el || !obj.quotes || !obj.quotes.length) return;
    for (const quote of obj.quotes) {
      const quoteWrapper = document.createElement('div'),
        wrapperAns = document.createElement('div'),
        sourceQuote = document.createElement('span'),
        preText = document.createElement('p'),
        answer = document.createElement('strong'),
        postText = document.createElement('p');
      quoteWrapper.className = 'quote-wrapper';
      wrapperAns.className = 'quote-wrapper-answer';
      sourceQuote.className = 'source-text';
      preText.className = 'pre-text';
      answer.className = 'answer-text';
      postText.className = 'post-text';
      sourceQuote.innerText = quote.source ?? '';
      preText.innerText = quote.pretext;
      answer.innerText = quote.quote;
      postText.innerText = quote.posttext;
      quoteWrapper.appendChild(sourceQuote)
      wrapperAns.appendChild(preText)
      wrapperAns.appendChild(answer)
      wrapperAns.appendChild(postText)
      quoteWrapper.appendChild(wrapperAns)
      quoteWrapper.style.opacity = 0;
      el.appendChild(quoteWrapper)
      answer.style.minHeight = `${answer.offsetHeight}px`;
      quoteWrapper.style.opacity = 1;
      await this.typeWriter(answer, quote.quote, 5);
    }
    if (obj.followUpQuestion) {
      const followUpQnst = document.createElement('p');
      followUpQnst.className = 'follow-up-question';
      el.appendChild(followUpQnst)
      await this.typeWriter(followUpQnst, obj.followUpQuestion, 5);
    }
  }

  async renderAnswer(obj, el = null) {
    if (!el || !obj.answer) return;
    const parentBlock = document.createElement('div'),
      timeBlock = document.createElement('span'),
      aiName = document.createElement('span'),
      titleAnswer = document.createElement('span'),
      answerWrapper = document.createElement('div'),
      iconBlock = document.createElement('div');
    iconBlock.className = 'logo-icon-answer';
    iconBlock.innerHTML = `
    <svg width="33" height="33">
      <use href="#icon-search-chat"/>
    </svg>
  `;
    parentBlock.appendChild(timeBlock)
    parentBlock.appendChild(aiName)
    parentBlock.appendChild(iconBlock)
    parentBlock.appendChild(titleAnswer)
    parentBlock.appendChild(answerWrapper)
    parentBlock.className = 'answer-wrapper';
    titleAnswer.className = 'title-answer';
    timeBlock.className = 'answer-time';
    answerWrapper.className = 'answer';
    aiName.className = 'ai-name';
    aiName.innerText = 'Escribió:';
    timeBlock.innerText = this.formatDate(new Date(), 'HH:mm');
    el.appendChild(parentBlock);
    const formattedAnswer = this.parseMarkdown(obj.answer);
    // titleAnswer.innerHTML = formattedAnswer;
    await this.typeWriter(titleAnswer, formattedAnswer, 5);


    await this.renderQuote(obj, answerWrapper);
  }

  renderQuestion(text, el) {
    const parentBlock = document.createElement('div');
    const timeBlock = document.createElement('span');
    const userName = document.createElement('span');
    const question = document.createElement('p');
    parentBlock.className = 'question-wrapper';
    timeBlock.className = 'question-time';
    question.className = 'question';
    userName.className = 'user-name';
    userName.innerText = 'Escribiste:';
    timeBlock.innerText = this.formatDate(new Date(), 'HH:mm');
    question.innerText = text;
    parentBlock.appendChild(timeBlock)
    parentBlock.appendChild(userName)
    parentBlock.appendChild(question)
    el.appendChild(parentBlock);
  }
}
new ChatNotes()
